export const getFilterButtonsConfig = (onListAll, onFilter, userRole) =>  [  
  {
    func: onListAll,
    icon: 'list',
    name: 'Listar todos',
    isDisabled:  userRole === 'empleado' ? true : false,
    isDropdown: false,
    dropdownItems: []
  },
  {
    func: onFilter,
    icon: 'filter_list',
    name: 'Filtros',
    isDropdown: false,
    dropdownItems: [],
    isDisabled: userRole !== 'administrador' ? true : false
  }
];